import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

function ProntuarioList() {
    const [prontuarios, setProntuarios] = useState([]);
    // Estado inicializado a partir do localStorage (padrão: 'alfabetica')
    const [sortType, setSortType] = useState(() => {
        return localStorage.getItem('prontuarios_sort_type') || 'alfabetica';
    }); 
    const navigate = useNavigate();

    const formatDate = (dateString) => {
        if (!dateString) return null;
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit'
        };
        return new Date(dateString).toLocaleString('pt-BR', options);
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/');
            return;
        }

        axios.get('https://ipj-api.vercel.app/api/prontuarios', {
            headers: {
                'Authorization': token
            }
        })
            .then(response => setProntuarios(response.data))
            .catch(error => {
                console.error(error);
                navigate('/');
            });
    }, [navigate]);

    const prontuariosOrdenados = [...prontuarios].sort((a, b) => {
        if (sortType === 'alfabetica') {
            return a.nome.localeCompare(b.nome);
        } else {
            const dateA = new Date(a.data_ultima_alteracao || a.data_criacao);
            const dateB = new Date(b.data_ultima_alteracao || b.data_criacao);
            return dateB - dateA;
        }
    });

    const handleSwitchChange = () => {
        setSortType(prev => {
            const next = prev === 'alfabetica' ? 'recente' : 'alfabetica';
            localStorage.setItem('prontuarios_sort_type', next);
            return next;
        });
    };

    return (
        <div className="prontuario-list-container">
            <h2>Lista de Prontuários</h2>
            
            {/* Contêiner do Switch */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <span style={{ 
                    marginRight: '10px', 
                    fontWeight: sortType === 'alfabetica' ? 'bold' : 'normal',
                    color: sortType === 'alfabetica' ? '#333' : '#888'
                }}>
                    Ordem Alfabética
                </span>
                
                <label style={{ position: 'relative', display: 'inline-block', width: '50px', height: '24px', margin: 0 }}>
                    <input 
                        type="checkbox" 
                        checked={sortType === 'recente'}
                        onChange={handleSwitchChange}
                        style={{ opacity: 0, width: 0, height: 0 }}
                    />
                    <span style={{
                        position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: sortType === 'recente' ? '#007bff' : '#ccc',
                        transition: '.4s', borderRadius: '24px'
                    }}>
                        <span style={{
                            position: 'absolute', content: '""', height: '18px', width: '18px',
                            left: sortType === 'recente' ? '28px' : '3px', bottom: '3px',
                            backgroundColor: 'white', transition: '.4s', borderRadius: '50%',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}></span>
                    </span>
                </label>

                <span style={{ 
                    marginLeft: '10px', 
                    fontWeight: sortType === 'recente' ? 'bold' : 'normal',
                    color: sortType === 'recente' ? '#333' : '#888'
                }}>
                    Mais Recentes
                </span>
            </div>

            {prontuarios.length === 0 && <p>Carregando...</p>}
            <ul>
                {prontuariosOrdenados.map(prontuario => (
                    <li key={prontuario.id}>
                        <Link to={`/prontuarios/${prontuario.id}`}>{prontuario.nome}</Link>
                        <div className="date-info" style={{fontSize: '0.8em', color: '#666'}}>
                            <span>Criado em: {formatDate(prontuario.data_criacao)}</span>
                            {prontuario.data_ultima_alteracao && (
                                <span style={{marginLeft: '5px'}}>
                                    | Última alteração: {formatDate(prontuario.data_ultima_alteracao)}
                                </span>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
            <Link to="/criar-prontuario" className="criar-prontuario-link">Criar Novo Prontuário</Link>
        </div>
    );
}

export default ProntuarioList;